import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client';

import { captureException } from '@/infrastructure/errorHandler';

const useEnhancedQuery = <TData = any>(
  query: DocumentNode | TypedDocumentNode<any, OperationVariables>,
  options?: QueryHookOptions,
  breakOnError?: boolean
) => {
  const { data, loading, refetch, error, fetchMore } = useQuery<TData>(query, options);

  if (error) {
    captureException(error);
    if (breakOnError) throw error;
  }

  return {
    data,
    loading,
    error,
    refetch,
    fetchMore,
  };
};

export default useEnhancedQuery;
